import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card card-flush mt-6 mt-xl-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder mb-1" }, " Job's client rates ")
  ])
], -1)
const _hoisted_3 = { class: "card-body pt-0" }
const _hoisted_4 = { class: "d-flex flex-row justify-content-end" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_JobClientRatesTable = _resolveComponent("JobClientRatesTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", {
            class: "d-flex flex-column",
            key: _ctx.containerKey
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.job.book_from_branches, (branch) => {
              return (_openBlock(), _createElementBlock("div", {
                key: branch.id
              }, [
                _createVNode(_component_JobClientRatesTable, {
                  branch: branch,
                  saveEvent: _ctx.saveEvent,
                  onAddToQueue: _ctx.addToQueue,
                  onRemoveFromQueue: _ctx.removeFromQueue
                }, null, 8, ["branch", "saveEvent", "onAddToQueue", "onRemoveFromQueue"])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "btn btn-success btn-sm w-150px",
                disabled: _ctx.isUpdating,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerSaveEvent && _ctx.triggerSaveEvent(...args)))
              }, [
                (_ctx.isUpdating)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                  : _createCommentVNode("", true),
                _hoisted_7
              ], 8, _hoisted_5)
            ])
          ]))
    ])
  ]))
}